/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Section_SummaryInputs */

const en_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const fr_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const de_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const it_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const ru_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const es_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const zh_cn2_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const ja_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const hi_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

const pt_pt2_options_metrics_section_summary = /** @type {(inputs: Options_Metrics_Section_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Tab`)
};

/**
* | output |
* | --- |
* | "Summary Tab" |
*
* @param {Options_Metrics_Section_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_section_summary = /** @type {((inputs?: Options_Metrics_Section_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Section_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_section_summary(inputs)
	if (locale === "de") return de_options_metrics_section_summary(inputs)
	if (locale === "it") return it_options_metrics_section_summary(inputs)
	if (locale === "ru") return ru_options_metrics_section_summary(inputs)
	if (locale === "es") return es_options_metrics_section_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_section_summary(inputs)
	if (locale === "ja") return ja_options_metrics_section_summary(inputs)
	if (locale === "hi") return hi_options_metrics_section_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_section_summary(inputs)
	return en_options_metrics_section_summary(inputs)
});